import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Save } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import GermanDateInput from "@/components/GermanDateInput";

const GROUPS = [
  ["Person", [["name", "Name"], ["email", "E-Mail"], ["phone", "Telefon"], ["birth_date", "Geburtsdatum", "date"], ["street", "Straße"], ["postal_code", "PLZ"], ["city", "Ort"]]],
  ["Kostenträger & Gutschein", [["kostentraeger", "Kostenträger (Jobcenter/Agentur)"], ["customer_number", "Kundennummer"], ["gutschein_number", "Bildungsgutschein-Nr."], ["measure_number", "Maßnahmenummer (abweichend)"]]],
  ["Arbeitsvermittler/in", [["arbeitsvermittler_name", "Name"], ["arbeitsvermittler_email", "E-Mail"], ["arbeitsvermittler_phone", "Telefon"]]],
];
const KEYS = GROUPS.flatMap(([, f]) => f.map(([k]) => k)).concat("notes");

export default function WbAkteStammdaten({ participant, onSaved, canEdit }) {
  const [f, setF] = useState({});
  const [busy, setBusy] = useState(false);
  useEffect(() => { setF(Object.fromEntries(KEYS.map((k) => [k, participant[k] || ""]))); }, [participant]);

  const save = async () => {
    setBusy(true);
    try {
      const payload = Object.fromEntries(Object.entries(f).filter(([k, v]) => v !== (participant[k] || "")));
      if (!Object.keys(payload).length) { toast.info("Keine Änderungen"); return; }
      const { data } = await api.put(`/weiterbildung/participants/${participant.participant_id}`, payload);
      toast.success("Stammdaten gespeichert");
      onSaved(data);
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message); } finally { setBusy(false); }
  };
  const cls = "mt-1 w-full border border-slate-200 px-2 py-1.5 text-sm text-slate-900 disabled:bg-slate-50";

  return (
    <div className="space-y-6" data-testid="wb-akte-stammdaten">
      {GROUPS.map(([title, fields]) => (
        <section key={title} className="border border-slate-200 bg-white p-5">
          <h3 className="text-[10px] font-bold uppercase tracking-overline text-slate-500 mb-3">{title}</h3>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
            {fields.map(([k, l, type]) => (
              <label key={k} className="text-xs text-slate-500">{l}
                {type === "date"
                  ? <GermanDateInput value={f[k] || ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} className={cls} disabled={!canEdit} data-testid={`wb-akte-${k}`} />
                  : <input value={f[k] || ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} className={cls} disabled={!canEdit} data-testid={`wb-akte-${k}`} />}
              </label>
            ))}
          </div>
        </section>
      ))}
      <section className="border border-slate-200 bg-white p-5">
        <h3 className="text-[10px] font-bold uppercase tracking-overline text-slate-500 mb-3">Notizen</h3>
        <textarea rows={4} value={f.notes || ""} onChange={(e) => setF({ ...f, notes: e.target.value })} className={cls} disabled={!canEdit} data-testid="wb-akte-notes" />
      </section>
      {canEdit && (
        <button onClick={save} disabled={busy} className="inline-flex items-center gap-2 bg-slate-900 text-white px-5 py-2.5 text-sm hover:bg-slate-700 transition-colors disabled:opacity-50" data-testid="wb-akte-save-btn">
          <Save size={14} /> Stammdaten speichern
        </button>
      )}
    </div>
  );
}
